<template>
  <div class="mb-3 position-relative">
    <div
      v-if="rejectAsk"
      class="position-relative file reject-message"
    >
      <textarea
        v-model="message"
        :placeholder="$t('view-CampaignsFiles.status.reject-message.placeholder')"
        :class="`form-control reject-message ${Boolean(message) ? 'is-valid' : 'is-invalid'}`"
      />
    </div>
    <a
      v-else
      :class="`position-relative d-block file show-${background.type}`"
      :style="`background-image: url(${background.url})`"
      :href="file.url"
      target="_black"
    >
      <span class="file-date">{{ formatedDate }}</span>
    </a>
    <div class="info mt-2 text-center">
      <div v-if="isAdvertiser && !file.accepted">
        <div
          v-if="buttonLoader"
          class="d-flex d-flex justify-content-center align-items-center accept-ask"
        >
          <b-spinner
            label="Spinner"
            class="loader"
          />
        </div>
        <div
          v-else-if="rejectAsk === false && acceptAsk === false"
          class="d-flex d-flex justify-content-between align-items-center accept-ask"
        >
          <div
            class="reject-btn"
            :style="`background-image: url(${$publicPath}img/campaigns/x.svg)`"
            @click="rejectAsk = true"
          />
          <div>{{ $t('view-CampaignsFiles.status.question') }}</div>
          <div
            class="accept-btn"
            :style="`background-image: url(${$publicPath}img/campaigns/ok.svg)`"
            @click="acceptAsk = true"
          />
        </div>
        <div
          v-else
          class="d-flex d-flex justify-content-between align-items-center accept-ask"
        >
          <div
            class="reject-btn"
            :style="`background-image: url(${$publicPath}img/campaigns/back.svg)`"
            @click="() => { rejectAsk = false; acceptAsk = false; }"
          />
          <div>{{ rejectAsk ? $t('view-CampaignsFiles.status.reject-ask-confirm') : $t('view-CampaignsFiles.status.accept-ask-confirm') }}</div>
          <div
            class="accept-btn"
            :style="`background-image: url(${$publicPath}img/campaigns/send-${rejectAsk ? 'red' : 'green'}.svg)`"
            @click="rejectAsk ? reject() : accept()"
          />
        </div>
      </div>
      <div
        v-else
        class="file-status"
      >
        <span
          v-if="file.accepted === 'accepted'"
          :style="`background-image: url(${$publicPath}img/campaigns/ok.svg)`"
        >{{ $t('view-CampaignsFiles.status.accepted') }}</span>
        <span
          v-else-if="file.accepted === 'rejected'"
          :style="`background-image: url(${$publicPath}img/campaigns/x.svg)`"
        >{{ $t('view-CampaignsFiles.status.rejected') }}</span>
        <span
          v-else
          :style="`background-image: url(${$publicPath}img/campaigns/wait.svg)`"
        >{{ $t('view-CampaignsFiles.status.waiting') }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    member: {
      type: Object,
      default: () => { return {} }
    },
    file: {
      type: Object,
      default: () => { return {} }
    }
  },
  data: function () {
    return {
      rejectAsk: false,
      acceptAsk: false,
      buttonLoader: false,
      message: ''
    }
  },
  computed: {
    background () {
      const split = this.file.url.split('.')
      const extension = split[split.length - 1]
      const result = {
        url: '',
        type: 'icon'
      }

      if (['jpg', 'png', 'svg'].includes(extension)) {
        result.url = this.file.url
        result.type = 'image'
      } else if (this.file.type === 'url') {
        result.url = this.$publicPath + 'img/campaigns/url.png'
      } else if (this.file.type === 'file') {
        result.url = this.$publicPath + 'img/campaigns/file.png'
      }

      return result
    },
    formatedDate () {
      const cDate = this.$dateString(this.file.created_at)
      return cDate[0] + ', ' + cDate[1]
    },
    isAdvertiser () {
      return this.$store.state.user.profile.type === 'advertiser'
    }
  },
  methods: {
    accept () {
      if (this.buttonLoader) {
        return
      }

      this.buttonLoader = true
      this.$store.dispatch('campaignsFiles/accept', this.file.id)
        .then(() => {
          this.$flash.success(this.$t('view-CampaignsFiles.message.accepted'))
          this.reset()
        }).catch((e) => {
          this.$flash.error(this.$t('view-CampaignsFiles.message.accepted-error'))
          this.buttonLoader = false
        })
    },
    reject () {
      if (!this.message) {
        this.$flash.warning(this.$t('view-CampaignsFiles.message.empty-message'))
        return
      }
      if (this.buttonLoader) {
        return
      }

      this.buttonLoader = true
      this.$store.dispatch('campaignsFiles/reject', { fileId: this.file.id, message: this.message })
        .then(() => {
          this.$flash.success(this.$t('view-CampaignsFiles.message.rejected'))
          this.reset()
        }).catch((e) => {
          this.$flash.error(this.$t('view-CampaignsFiles.message.rejected-error'))
          this.buttonLoader = false
        })
    },
    reset (successMessage) {
      this.rejectAsk = false
      this.acceptAsk = false
      this.message = ''
      console.log('A')
      const fileReload = this.$store.dispatch('campaignsFiles/getFiles', this.member.id)
      const statusReload = this.$store.dispatch('campaignsMembersAdvertiser/getMembers', this.member.campaign_id)
      Promise.all([fileReload, statusReload]).catch(e => { this.buttonLoader = false }).then(() => { this.buttonLoader = false })
    }
  }
}
</script>

<style lang="scss" scoped>
  .file {
    background-color: #fafafa;
    border-radius: 5px;
    border: solid $nh-gray 2px;
    background-repeat: no-repeat;
    background-position: center;
    &:after {
      content: "";
      display: block;
      padding-bottom: 100%;
    }
  }
  .show-icon {
    background-size: 40px;
  }
  .show-image {
    background-size: cover;
  }
  .file-date {
    position: absolute;
    top: 10px;
    left: 10px;
    background-color: $warning;
    padding: 0 0.5rem;
    border-radius: 5px;
    font-size: 0.625rem;
    font-weight: 500;
  }
  .reject-message {
    height: 100%;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
  }
  .info {
    border-radius: 5px;
    border: solid $nh-gray 2px;
    font-size: 0.7rem;
    font-weight: 600;
    overflow: hidden;
    .file-status {
      span {
        display: inline-block;
        width: 100%;
        padding: 0.25rem 0.5rem;
        background-position: 5px center;
        background-repeat: no-repeat;
        background-size: 18px;
      }
    }

    .accept-btn, .reject-btn {
      display: inline-block;
      padding: 0.81rem 1rem;
      background-repeat: no-repeat;
      background-position: center;
      cursor: pointer;
    }
    .accept-btn {
      border-left: 2px solid $nh-gray;
    }
    .reject-btn  {
      border-right: 2px solid $nh-gray;
    }
  }
  .accept-ask {
    ::v-deep .loader {
      margin: 0.25rem;
      height: 18px;
      width: 18px;
    }
  }
</style>
